module.exports = __webpack_public_path__ + "38f7049e454748ed9e3947096b746e81.png";